import { useState } from 'react';
import RoomIcon from '../../assets/images/rooms.png';

import { roomAPI } from '../../api/roomAPI';

export default function RoomSearch({ setRoomNo, setOccupyNo, setCusCode, setCusName, setFromPCode, disabled }) {

    const [inputKey, setInputKey] = useState('');
    const [rooms, setRooms] = useState([]);

    const onChangeInputKey = (key) => {
        setInputKey(key);

        roomAPI.searchRooms(key).then((data) => setRooms(data));
    }

    const onSelectRoom = (roomNo, occupyNo, cusCode, cusName, fromPCode) => {
        setRoomNo(roomNo);
        setOccupyNo(occupyNo);
        setCusCode(cusCode);
        setCusName(cusName);
        setFromPCode(fromPCode);

        document.getElementById("modalPOSRoomSearch_close").click();
    }

    return (
        <>

            {
                disabled === false ? <button className="btn btn-primary form-control" data-bs-toggle="modal" data-bs-target="#modalPOSRoomSearch">
                    Room <span className="d-none d-lg-inline d-xl-inline d-xxl-inline">Search</span>
                    <img src={RoomIcon} alt="" className="ms-1" />
                </button>
                    :
                    <button className="btn btn-primary form-control" data-bs-toggle="modal" data-bs-target="#modalPOSRoomSearch" disabled>
                        Room <span className="d-none d-lg-inline d-xl-inline d-xxl-inline">Search</span>
                        <img src={RoomIcon} alt="" className="ms-1" />
                    </button>
            }

            <div id="modalPOSRoomSearch" className="modal fade" role="dialog">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title text-danger text-center">Search Room</h4>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                                    Search
                                    <input type="text" className="form-control" value={inputKey}
                                        onInput={(e) => onChangeInputKey(e.target.value)} maxLength="50"
                                        placeholder="Search by room # / guest name" />
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                                    <table className="table table-sm table-hover">
                                        <thead className="thead--color">
                                            <tr>
                                                <td>Room #</td>
                                                <td>Guest</td>
                                                <td>Basis</td>
                                                <td>Property</td>
                                                <td className="text-center">Action</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                rooms.map((data, index) => (
                                                    <tr key={index}>
                                                        <td>{data.roomNo}</td>
                                                        <td>{data.guestName}</td>
                                                        <td>{data.basis}</td>
                                                        <td>{data.pname}</td>
                                                        <td className="text-center">
                                                            <button type="button" className="btn btn-sm btn-primary"
                                                                onClick={() => onSelectRoom(data.roomNo, data.occupyNo, data.cusCode,
                                                                                                data.guestName,data.pcode)}                                                           >
                                                                Select
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="row mt-1">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 px-12">
                                    <button className="btn btn-secondary form-control mt-1" data-bs-dismiss="modal"
                                        id="modalPOSRoomSearch_close">
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}